import { Component, Input, OnDestroy, OnInit } from '@angular/core';

@Component({
  selector: 'app-audio-player',
  templateUrl: './audio-player.component.html',
  styleUrls: ['./audio-player.component.css']
})
export class AudioPlayerComponent implements OnInit, OnDestroy {

  @Input() audioUrl!: string;
  audio = new Audio();
  isPlaying = false;
  progress = 0;
  currentTime = '00:00';
  duration = '00:00';

  ngOnInit(): void {
    this.audio.src = this.audioUrl;
    this.audio.load();

    // Fetch duration when audio metadata is loaded
    this.audio.addEventListener('loadedmetadata', () => {
      this.duration = this.formatTime(this.audio.duration);
    });

    // Update progress & current time dynamically
    this.audio.addEventListener('timeupdate', () => {
      this.progress = (this.audio.currentTime / this.audio.duration) * 100;
      this.currentTime = this.formatTime(this.audio.currentTime);
    });
  }

  ngOnDestroy(): void {
    if (this.isPlaying) {
      this.stop();
    }
  }

  play(): void {
    this.audio.play();
    this.isPlaying = true;
  }

  pause(): void {
    this.audio.pause();
    this.isPlaying = false;
  }

  stop(): void {
    this.audio.pause();
    this.audio.currentTime = 0;
    this.isPlaying = false;
  }

  seek(event: any): void {
    const newPosition = event.target.value;
    this.progress = newPosition;
    this.audio.currentTime = (newPosition / 100) * this.audio.duration;
  }

  download(): void {
    const anchor = document.createElement('a');
    anchor.href = this.audioUrl;
    anchor.download = this.audioUrl.substring(this.audioUrl.lastIndexOf('/') + 1);
    anchor.click();
  }

  // Function to format time in mm:ss
  formatTime(seconds: number): string {
    const minutes = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  }
}